export const query = (state) => state.router.location.query;
export const pathname = (state) => state.router.location.pathname;
export const mobile = (state) => state.ui.mobile === true;
export const param = (id) => (state) => state?.ui?.params[id];
export const activeRouteId = (state) => state.ui.activeRouteId;
export const isInitializing = (state) => state.ui.isInitializing;
